module.exports = __webpack_public_path__ + "static/media/claveunica.6a665c31.svg";